import { Text } from 'styles/themeColors';
import { capitalize, formatDateTime } from '../../utils/formatters';
import { LegacyColumn as Column } from 'components/MaterialTable/MatDataGridTypes';
import { GENERAL_CONSTANTS } from 'constants/general';
import { ORGANIZATION_CONSTANTS } from 'constants/organization';

const BusinessUnitTableColumns: Column<any>[] = [
    {
        title: '',
        field: 'imagePath',
        width: '40px',
        sorting: false,
        align: 'left',
        cellStyle: { padding: '16px 12px' },
    },
    {
        title: GENERAL_CONSTANTS.NAME,
        field: 'name',
        headerStyle: { color: Text.primary },
        width: '25%',
        sorting: true,
        render: (rowData) => capitalize(rowData.name, 'N/A'),
        cellStyle: { padding: '16px 8px' },
    },
    {
        title: GENERAL_CONSTANTS.BRAND,
        field: 'brandName',
        headerStyle: { color: Text.primary },
        sorting: true,
        cellStyle: { padding: '16px 8px' },
    },
    {
        title: ORGANIZATION_CONSTANTS.NUMBER_OF_USERS,
        field: 'usersCount',
        headerStyle: { color: Text.primary },
        sorting: false,
        cellStyle: { padding: '16px 8px' },
        disableClick: true
    },
    {
        title: GENERAL_CONSTANTS.CREATED_DATE,
        field: 'createdOn',
        headerStyle: { color: Text.primary },
        sorting: true,
        render: (rowData) => rowData.createdOn ? formatDateTime(rowData.createdOn) : 'N/A',
        cellStyle: { padding: '16px 8px' },
    },
    {
        title: '',
        field: 'actions',
        removable: false,
        sorting: false,
        cellStyle: { padding: '16px 8px' },
    }
]

export { BusinessUnitTableColumns };